import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationService } from '@vsp/angular-core-libraries';
import { TokenInterceptor } from './interceptors/TokenInterceptor';
import { RestApiInterceptor } from './interceptors/RestApiInterceptor';
import { OrderStatusFormatPipe } from './pipes/order-status-format.pipe';

@NgModule({
  declarations: [OrderStatusFormatPipe],
  imports: [CommonModule],
  providers: [
    AuthenticationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RestApiInterceptor,
      multi: true,
    },
  ],
  exports: [OrderStatusFormatPipe],
})
export class CoreModule {}
